module.exports = __webpack_public_path__ + "static/media/img6.ca652463.jpg";